'use client';
import React, { useState, useEffect, useRef } from 'react';
import { RichTreeView } from '@mui/x-tree-view/RichTreeView';
import { TreeViewBaseItem } from '@mui/x-tree-view/models';
import './WorkflowStructure.css';
import { getExpandedIdsFromWfNodes, parseXmlToTree } from '@/utils/xmlPraser';

interface Props {
  xmlTree: any[]; // parsed XML structure
  allWorkflowsSelections: string[];
  updateTemplateDetails: (key: string, value: string) => void;
  setTemplateDetailsData: any;
  templateDetailsData: any;
  editTemp: any;
  templateId: any
}

export default function WorkflowStructure(props: Props) {
  const [treeItems, setTreeItems] = useState<TreeViewBaseItem[]>([]);
  const [expandedItems, setExpandedItems] = useState<string[]>([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);

  const hasRunRef = useRef(false);
  // Parse and set tree items
  useEffect(() => {
    if (props.xmlTree) {
      const { tree, expandedIds } = parseXmlToTree(props.xmlTree);
      setTreeItems(tree);
      setExpandedItems(expandedIds);
    }
  }, [props.xmlTree, props.templateDetailsData.wfNodes]);


  useEffect(() => {
    hasRunRef.current = false;
  }, [props.templateId]);

  useEffect(() => {
    if (treeItems.length && props.templateDetailsData?.wfNodes && !hasRunRef.current) {
      const rootLabel = treeItems[0]?.label;
      const selectedIds = getExpandedIdsFromWfNodes(
        props.templateDetailsData.wfNodes,
        rootLabel
      );
      hasRunRef.current = true;
      setSelectedItems(selectedIds);
    }
  }, [treeItems, props.editTemp, props.templateId]);

  const handleSelectedItemsChange = (_event: any, ids: string[]) => {
    setSelectedItems(ids);
    const allSelectedWFNodes = convertArrayToString(ids);
    props.setTemplateDetailsData((prev) => ({
      ...prev,
      wfNodes: allSelectedWFNodes,
  }));
  };

  // Helper to convert selected paths to a comma-separated format
  const convertArrayToString = (arr: string[]) => {
    const resultSet = new Set<string>();
    arr.forEach(item => {
      const parts = item.split('>');
      let current = '';
      parts.forEach((part, index) => {
        current = index === 0 ? part : current + '>' + part;
        resultSet.add(current);
      });
    });
    return Array.from(resultSet).join(',');
  };

  return (
    <div className="tree-wrapper" style={{ position: 'relative' }}>
      <div className="tree-container">
        <RichTreeView
          items={treeItems}
          checkboxSelection
          multiSelect
          selectedItems={selectedItems}
          onSelectedItemsChange={handleSelectedItemsChange}
          expandedItems={expandedItems}
          onExpandedItemsChange={(_event, ids) => setExpandedItems(ids)}
        />
      </div>
    </div>
  );
}
